<script>
    import QuestionTypes from '../lib/QuestionTypes';

    import {sortBy} from 'lodash-es';

    export let control;
    export let model;
    export let assessment;
    export let domain = '';
    export let assessor = false;

    export let ro = false;

    function getAnswer(control) {
        if (assessor) {
            return model.getAnswer(assessor, control.id, domain, assessment);
        } else {
            return model.getResult(control.id, domain, assessment);
        }
    }

    function setAnswer(control, answer) {
        if (assessor) {
            model.setAnswer(assessor, control.id, domain, answer);
        } else {
            model.setResult(control.id, domain, answer);
        }
    }

    $: answer = getAnswer(control).value
</script>

<div>
    {#if control.question_type == "free_text"}
        <input
            class="input"
            value={answer || ""}
            readonly={ro ? "readonly" : undefined}
            on:change={(evt) => setAnswer(control, evt.target.value)}
            placeholder="Answer"
        >
    {:else}
        <div class="buttons has-addons">
            {#each sortBy(Object.values(QuestionTypes[control.question_type || "implementation_status"].buttons), ["order"]) as btn}
                {#if !ro || answer == btn.value}
                    <button
                        class="button {answer == btn.value ? btn.color : ''}"
                        class:ro={ro}
                        on:click={() => !ro && setAnswer(control, btn.value)}
                    >
                        {btn.label}
                        <!--
                            {#if control.recommendation_map[btn.value]}
                                &#10057;
                            {/if}
                        -->
                    </button>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .ro {
        cursor: default;
    }
</style>